import { useMemo } from 'react'
import { currentTz } from '../helpers/time'

export const useEventTimezoneInfoIcon = (eventTimezone) => {
  const shouldShow = useMemo(
    () => Boolean(eventTimezone && currentTz && eventTimezone !== currentTz),
    [eventTimezone],
  )

  const title = useMemo(() => {
    if (!shouldShow) return ''
    return (
      `Shift times are in the event timezone (${eventTimezone}). `
      + `Your device timezone: ${currentTz}.`
    )
  }, [shouldShow, eventTimezone])

  return { shouldShow, title }
}
